import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './main.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../material.module';
import { InternasionalPhoneModule } from '../shared/components/internasional-phone/internasional-phone.module';
import { LoaderModule } from '../shared/components/loader/loader.module';
import { SharedModule } from '../shared/shared.module';
import { ChatComponent } from '../supprot-chat/chat/chat.component';
import { FormComponent } from '../support-form/form/form.component';
import { SupportFormModule } from '../support-form/support-form.module';
import { SupprotChatBoxModule } from '../supprot-chat/supprot-chat-box.module';
import { SideBarComponent } from './sideBar/sideBar.component';
import { CandidateModule } from '../candidate/candidate.module';
import { CandidateShowingsComponent } from '../candidate/components/candidateShowings/candidateShowings.component';
import { FinalizeComponent } from '../shared/components/finalize/finalize.component';
import { ProfileComponent } from './profile/profile.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full'},
  {
    path: 'chat',
    component: ChatComponent
  },
  {
    path: 'request',
     children: [
      {
        path: '',
        redirectTo: 'request/contact-info',
        pathMatch: 'full'
      },
      {
        path: 'contact-info',
        component: FormComponent
      },
      {
        path: 'form',
        component: FormComponent
      },
    ]
   
  },
  {
    path: 'generalError',
    component: FinalizeComponent
  },
  {
    path: 'create-ticket-error',
    component: FinalizeComponent
  },
  {
    path: 'create-ticket-success',
    component: FinalizeComponent
  },
  {
    path: 'check-in',
    component: FinalizeComponent
  },
  {
    path: 'check-out',
    component: FinalizeComponent
  },
  {
    path: 'profile',
    component: ProfileComponent
  },
  {
    path: 'my-showings',
    children: [
      {
        path: '',
        component: CandidateShowingsComponent
      },
    
    ]
  }
]
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    InternasionalPhoneModule,
    MaterialModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    LoaderModule,
    RouterModule.forChild(routes),
    SupportFormModule,
    SupprotChatBoxModule,
    CandidateModule
  ],
  declarations: [MainComponent,SideBarComponent,ProfileComponent],
  exports: [MainComponent,SideBarComponent]
})
export class MainModule { }
